import { TradingPlan } from '../../../interfaces/User';

interface PlanMobileProps {
	getTitle: (
		plan: TradingPlan
	) => 'Request Upgrade' | 'Request Plan' | 'Nil' | 'Active' | 'Requested';
	onPlanClick: (
		plan: TradingPlan,
		title: 'Request Upgrade' | 'Request Plan'
	) => void;
}

const PlanMobile: React.FC<PlanMobileProps> = ({ getTitle, onPlanClick }) => {
	return (
		<div className='bv-plan-mobile py-3'>
			<div className='blog-wrapper'>
				<div className='container'>
					<div className='row g-3'>
						<div className='col-6 col-sm-4 col-md-3'>
							<div className='card position-relative shadow-sm'>
								<center>
									<h3 className='text-uppercase'>
										<u>Beginner</u>
									</h3>
									<h4>
										<span className='badge bg-danger rounded-pill mb-2 d-inline-block'>
											$3,000.00
										</span>
									</h4>
									<h4></h4>
								</center>

								<div className='card-body'>
									<p>
										<strong></strong> Trades/Day
									</p>
									<p>
										<strong>ATS</strong>
									</p>
									<br />
									<br />
									<button
										className='btn btn-bold btn-block btn-outline btn-dark'
										onClick={() => {
											const title = getTitle('Beginner-3000');

											if (
												title === 'Request Plan' ||
												title === 'Request Upgrade'
											) {
												onPlanClick('Beginner-3000', title);
											}
										}}
										disabled={getTitle('Beginner-3000') === 'Nil'}
									>
										{getTitle('Beginner-3000')}
									</button>
								</div>
							</div>
						</div>

						<div className='col-6 col-sm-4 col-md-3'>
							<div className='card position-relative shadow-sm'>
								<center>
									<h3 className='text-uppercase'>
										<u>Gold </u>
									</h3>
									<h4>
										<span className='badge bg-danger rounded-pill mb-2 d-inline-block'>
											$7,600.00
										</span>
									</h4>
									<h4></h4>
								</center>

								<div className='card-body'>
									<p>
										<strong>5</strong> Trades/Day
									</p>
									<p>
										<strong>ATS</strong>
									</p>

									<br />
									<br />
									<button
										className='btn btn-bold btn-block btn-outline btn-dark'
										onClick={() => {
											const title = getTitle('Gold-7600');

											if (
												title === 'Request Plan' ||
												title === 'Request Upgrade'
											) {
												onPlanClick('Gold-7600', title);
											}
										}}
										disabled={getTitle('Gold-7600') === 'Nil'}
									>
										{getTitle('Gold-7600')}
									</button>
								</div>
							</div>
						</div>

						<div className='col-6 col-sm-4 col-md-3'>
							<div className='card position-relative shadow-sm'>
								<center>
									<h3 className='text-uppercase'>
										<u>Platinum </u>
									</h3>
									<h4>
										<span className='badge bg-danger rounded-pill mb-2 d-inline-block'>
											$21,199.00
										</span>
									</h4>
									<h4></h4>
								</center>

								<div className='card-body'>
									<p>
										<strong>10</strong> Trades/Day
									</p>
									<p>
										<strong>ATS</strong>
									</p>

									<br />
									<br />
									<button
										className='btn btn-primary btn-sm'
										onClick={() => {
											const title = getTitle('Platinum-21199');

											if (
												title === 'Request Plan' ||
												title === 'Request Upgrade'
											) {
												onPlanClick('Platinum-21199', title);
											}
										}}
										disabled={getTitle('Platinum-21199') === 'Nil'}
									>
										{getTitle('Platinum-21199')}
									</button>
								</div>
							</div>
						</div>

						<div className='col-6 col-sm-4 col-md-3'>
							<div className='card position-relative shadow-sm'>
								<center>
									<h3 className='text-uppercase'>
										<u>Diamond </u>
									</h3>
									<h4>
										<span className='badge bg-danger rounded-pill mb-2 d-inline-block'>
											$50,730.00
										</span>
									</h4>
									<h4></h4>
								</center>

								<div className='card-body'>
									<p>
										<strong>14</strong> Trades/Day
									</p>
									<p>
										<strong>ATS (VIP)</strong>
									</p>
									<br />
									<br />
									<button
										className='btn btn-primary btn-sm'
										onClick={() => {
											const title = getTitle('Diamond-50730');

											if (
												title === 'Request Plan' ||
												title === 'Request Upgrade'
											) {
												onPlanClick('Diamond-50730', title);
											}
										}}
										disabled={getTitle('Diamond-50730') === 'Nil'}
									>
										{getTitle('Diamond-50730')}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PlanMobile;
